module.exports = __webpack_public_path__ + "6fd80b1f51b2b05b6d054b67a8b37e55.png";